import { ForwardedRef, forwardRef } from 'react'
import { ControlSize, Gradient } from 'types'
import { Button, Options } from './style'

type Props = {
    activeIndex?: number
    backgroundColor: string
    className?: string
    controlColor: string
    controlId: string
    controlSize: ControlSize
    gradient?: Gradient
    options: string[]
    onChange: (index: number) => void
}

const SegmentedControlOptions = (
    {
        activeIndex,
        backgroundColor,
        className,
        controlColor,
        controlId,
        controlSize,
        gradient,
        options,
        onChange,
    }: Props,
    ref: ForwardedRef<HTMLDivElement>
) => {
    return (
        <Options className={className} ref={ref}>
            {options.map((label, i) => {
                const isActive = i === activeIndex

                return (
                    <Button
                        active={isActive}
                        color={isActive ? controlColor : backgroundColor}
                        size={controlSize}
                        gradient={isActive ? gradient : undefined}
                        key={`${controlId}-option${i}`}
                        style={isActive ? undefined : { opacity: 0.5 }}
                        onClick={() => onChange(i)}
                    >
                        {label}
                    </Button>
                )
            })}
        </Options>
    )
}

export default forwardRef(SegmentedControlOptions)
